import PropTypes from 'prop-types'

const Input = ({ error, input, register, style, userInputs, label }) => {
  const isNumber = input?.params?.validation?.number

  const getValidatons = () => {
    const validation = input?.params?.validation || {}
    return {
      required: validation.required,
      min: Number(validation.min),
      max: Number(validation.max),
      pattern: validation.number ? /[0-9]+/ : undefined,
      valueAsNumber: validation.number,
    }
  }

  return (
    <div style={style}>
      {label && <label htmlFor={input.name}>{label}</label>}
      <input
        defaultValue={(userInputs && userInputs[input.name]) || input.defaultValue}
        type={isNumber ? 'number' : 'text'}
        name={input.name}
        {...register(input.name, getValidatons())}
      />
      {error && <span>{error}</span>}
    </div>
  )
}

Input.propTypes = {
  error: PropTypes.string,
  input: PropTypes.object.isRequired,
  label: PropTypes.string,
  register: PropTypes.func.isRequired,
  style: PropTypes.object,
  userInputs: PropTypes.object.isRequired,
}

export default Input
